import { useState } from 'react';
import { assignDraftTechnique, draftRows } from './mfsDraft.model';
import styles from './TechniqueAssignments.module.css';

export default function TechniqueAssignments({ catalog, draft, setDraft }) {
  const [query, setQuery] = useState('');
  const [subsystem, setSubsystem] = useState('');
  const [custom, setCustom] = useState('');
  const [error, setError] = useState('');
  const selected = draftRows(draft, catalog);
  const visible = selected.filter(row => (!subsystem || row.subsystem === subsystem) &&
    [row.name, row.code, row.siteLabel, row.assetLabel].join(' ').toLowerCase().includes(query.trim().toLowerCase()));
  const missing = selected.filter(row => !draft.assignments[row.key]?.length).length;
  function setTechnique(ids, technique, enabled) {
    setDraft(previous => assignDraftTechnique(previous, ids, technique, enabled));
  }
  function addTechnique() {
    const code = custom.trim().toUpperCase();
    if (!/^[A-Z0-9][A-Z0-9 _-]{0,19}$/.test(code)) {
      setError('Use 1–20 letters, numbers, spaces, underscores or hyphens.'); return;
    }
    setDraft(previous => ({ ...previous, techniques: [...new Set([...previous.techniques, code])] }));
    setCustom(''); setError('');
  }
  return <div className={styles.container}>
    <p>Assign methods per component. Column checkboxes change visible rows only. Every selected component needs at least one method.</p>
    <div className={styles.toolbar}>
      <label>Find component<input value={query} onChange={event => setQuery(event.target.value)} /></label>
      <label>Subsystem<select value={subsystem} onChange={event => setSubsystem(event.target.value)}>
        <option value="">All subsystems</option>
        {[...new Set(selected.map(row => row.subsystem))].map(value => <option key={value}>{value}</option>)}
      </select></label>
      <label>Additional method<input value={custom} maxLength={20} onChange={event => setCustom(event.target.value)} /></label>
      <button type="button" onClick={addTechnique}>Add method column</button>
    </div>
    {error && <p className={styles.error} role="alert">{error}</p>}
    <p><strong>{selected.length} components · {visible.length} visible · {missing} unassigned</strong></p>
    <div className={styles.scroll}><table>
      <caption>Technique requirements for this maintenance draft</caption>
      <thead><tr><th scope="col">Component / location</th>{draft.techniques.map(technique => {
        const count = visible.filter(row => draft.assignments[row.key]?.includes(technique)).length;
        return <th key={technique} scope="col"><label className={styles.cell}>
          <span>{technique}</span><input type="checkbox" disabled={!visible.length}
            checked={visible.length > 0 && count === visible.length}
            ref={node => { if (node) node.indeterminate = count > 0 && count < visible.length; }}
            aria-label={technique + ' for all visible components'}
            onChange={event => setTechnique(visible.map(row => row.key), technique, event.target.checked)} />
        </label></th>;
      })}</tr></thead>
      <tbody>{visible.map(row => <tr key={row.key} data-unassigned={!draft.assignments[row.key]?.length}>
        <th scope="row"><strong>{row.code}</strong> · {row.name}<small>{row.siteLabel} / {row.assetLabel}</small>
          <small>IOD eligibility: {row.eligible.join(' · ') || 'No eligible method recorded'}</small></th>
        {draft.techniques.map(technique => <td key={technique}><label className={styles.cell}>
          <input type="checkbox" aria-label={technique + ' · ' + row.code + ' · ' + row.siteLabel + ' / ' + row.assetLabel}
            checked={Boolean(draft.assignments[row.key]?.includes(technique))}
            onChange={event => setTechnique([row.key], technique, event.target.checked)} />
        </label></td>)}
      </tr>)}</tbody>
    </table></div>
    {!visible.length && <p>No components match this matrix filter. Hidden assignments are unchanged.</p>}
    <p className={styles.note}>IOD eligibility is shown as a planning aid. Draft assignments outside those flags require review; this draft does not approve an inspection method.</p>
  </div>;
}